import clsx from 'clsx'
import React from 'react'
import { PropsWithChildrenRequired } from '../../../types/PropsWithChildrenRequired'

type Props = {
    className?: string
}

function Card({
    children,
    className,
}: PropsWithChildrenRequired<Props>): React.JSX.Element {
    const allClasses = clsx('border rounded-lg p-4 bg-white w-full', className)

    return <div className={allClasses}>{children}</div>
}

export default Card
